export const PAGE_SIZE_OPTIONS = [25, 50, 100]
export type PageSizeOption = (typeof PAGE_SIZE_OPTIONS)[number]

export type Route = 'one-time' | 'automated'

export type UIFilters = {
  status?: string[]
  audience?: string[]
  trigger?: string[]
}
export type FilterBy = 'Status' | 'Audience' | 'Trigger'

export type Message = {
  City: string
  CollegeName: string
  Country: string
  CreatedById: string
  CreatedDate: string
  CreationSource: string // TYPES?
  Deleted: boolean
  Disabled: boolean
  Id: string
  IsDraft: boolean
  Link: string
  LinkLabel: string
  Message: string
  Priority: number
  ScheduledDate: string
  Scid: number
  Segment: {
    Id: string
    Version: number
    Criteria: {
      Must: Array<{ Name: string; Values: string[] }>
    }
  }
  SegmentId: string
  State: string
  Status: string
  Subject: string
  TotalClicked: number
  TotalOpened: number
  TotalSent: number
  Trigger: 'Marked-Applied' | 'Marked-Applying' | 'On-Follow' | 'One-Time'
  UpdatedDate: string
}

export type MessageResponse = {
  'One-Time': Message[]
  'On-Follow': Message[]
  'Marked-Applying': Message[]
  'Marked-Applied': Message[]
}

export type AllMessages = {
  automated: Message[]
  'one-time': Message[]
}

export type AutomatedMessagesByTrigger = {
  'On-Follow': Message[]
  'Marked-Applying': Message[]
  'Marked-Applied': Message[]
}
